import { render } from "./commodity.vue?vue&type=template&id=631497c2&scoped=true"
import script from "./commodity.vue?vue&type=script&lang=js"
export * from "./commodity.vue?vue&type=script&lang=js"

import "./commodity.vue?vue&type=style&index=0&id=631497c2&scoped=true&lang=css"

import exportComponent from "/root/workspace/adx-frontend_wteR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631497c2"]])

export default __exports__